
import { Box, CircularProgress } from '@mui/material';

function SemiCircleProgressBarChart({ percentage, diameter, strokeColor = '#ffffff', backgroundColor = 'rgba(255,255,255,0.2)', strokeWidth = 4 }) {
	const radius = diameter / 2;
  const size = diameter;

  return (
   
		<Box
			className="semicircle-progress"
			sx={{
				position: 'relative',
				width: size,
				height: radius,
				overflow: 'hidden',
			}}
		>
      {/* Background Circle */}
      <CircularProgress
        variant="determinate"
        value={50}
        size={size}
        thickness={strokeWidth}
				className='semicircle-progres__bg'
        sx={{
          color: backgroundColor,
        }}
      />

      {/* Foreground Progress */}
      <CircularProgress
        variant="determinate"
        value={percentage / 2}
        size={size}
        thickness={strokeWidth}
        sx={{
          color: strokeColor,
          position: 'absolute',
          left: 0,
          top: 0,
        }}
      />      
   </Box>
  );
}

export default SemiCircleProgressBarChart;
